import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppStyle from '../../../styles/App.module.css';
import { Modal} from '@material-ui/core';
import ActionButtons from '../ActionButtons/ActionButtons'

const WIDTH = 700;

const styles = theme => ({
    paper: {
        padding: '0px',
        position: 'absolute',
        // width: theme.spacing.unit * 50,
        width: `${WIDTH}px`,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        outline: 'none',
        left: `calc(50% - ${WIDTH / 2}px)`,
        top: '150px',
    }
});

class SimpleModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    render() {
        const { classes } = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.props.open}
                onClose={this.props.cancelModal}
            >
                <div className={classes.paper}>
                    <div className={AppStyle.Location__Title}>
                        <span>{this.props.titleModal}</span>
                    </div>
                    {this.props.children}
                    <ActionButtons 
                        cancel={this.props.cancelModal}
                        submit={this.props.submit}
                        disabledSubmit={this.props.disabledSubmit}
                    />
                </div>
            </Modal>
        );
    }
}
export default withStyles(styles)(SimpleModal);